import { useLocalStorage } from '@mantine/hooks';

export const HIDE_RESOURCE_MODULE_STORAGE_KEY = 'hide_resource_module';

export const useResourceModuleVisibility = () =>
  useLocalStorage<boolean>({
    key: HIDE_RESOURCE_MODULE_STORAGE_KEY,
    defaultValue: false,
    getInitialValueInEffect: false,
  });
